import React, { Component } from "react";
import { Field, formValueSelector } from 'redux-form';
import { connect } from "react-redux";
import { Row } from "react-foundation";

import { getWindowDesigns } from "actions";
import Loading from "components/Loading";
import Tick from "components/Tick";

import utils from "utils";

import SlickSlider from "components/SlickSlider";
import Image from "components/Image";
import InputError from "../../components/InputError";
import ThemeButton from "../../components/ThemeButton";
import Select from "react-select";
import SeparatingLine from "../../components/SeparatingLine";
import FormHeader from "../../components/FormHeader";
import FormWrapper from "../FormWrapper";

const DisplayDesign = (value, index, selectedValue) => {
    let selectedClass = value.id === selectedValue.toString() ? " selected" : "";

    return (
        <div key={index} className={selectedClass}>
            <div className="slick-slide-image-container">
                <Tick />
                <Image
                    src={value.externalImageUrl}
                    svg={value.svgImage}
                    alt={value.name}
                    className="slick-slide-image"
                />
            </div>
        </div>
    );
};

const SelectDesign = props => {
    let { designs, emptyDesigns, input } = props;

    if (emptyDesigns) {
        return <div>There is no design fitting these parameters</div>;
    }

    if (designs.length === 0) {
        return <Loading />;
    }

    let settings = {};

    if (!props.isTiltTurn) {
        settings.slidesToShow = 5;
    }

    return (
        <div className={props.className}>
            <Row isColumn>
                <SlickSlider
                    settings={settings}
                    values={designs}
                    selectedId={input.value}
                    onDisplay={(value, index) => DisplayDesign(value, index, input.value)}
                    onChange={input.onChange}
                />
            </Row>
            <InputError metas={props.meta} />
        </div>
    );
};

let CounterDropdown = props => {
    let options = [];

    if (props.from !== "" && props.to !== "") {
        for (let i = props.from; i <= props.to; i++) {
            options.push({ value: i, label: i });
        }
    }

    if (props.options) {
        for (let i = 0; i < props.options.length; i++) {
            let value = props.options[i];
            options.push({ value: value, label: value });
        }
    }

    if (options.length === 0) {
        options.push({ value: "", label: "" });
    }

    return (
        <Select
            value={props.value}
            onChange={val => props.onChange(val.value)}
            options={options}
            clearable={false}
            searchable={false}
            placeholder=""
        />
    );
};

class DesignForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            paneCountValue: "",
            openCountValue: ""
        };
    }
    componentDidMount() {
        // let itemTypeId = 1; // window

        this.props.getWindowDesigns(this.props.windowStyleId);
    }

    onSubmit(values) {

        let windowDesignId = values.WindowDesignId;

        let design = utils.getValueById(this.props.designs, windowDesignId);

        this.props.setDesign(design);

        this.props.onSubmit(values);
    }


    getDesignOptions(designs, optionName) {
        let options = [];

        options = [...new Set(designs.map(d => d[optionName]))];

        options.sort();

        return options;
    }

    render() {
        let paneCountClasses = "pane-count";
        let openCountClasses = "open-count";
        let designClasses = "design-field";

        let smallHideClass = "";

        if (this.state.openCountValue !== "") {
            openCountClasses += " fadeout";
            designClasses += " fadein";
            smallHideClass = "hide-for-small-only";
        }

        if (this.state.paneCountValue !== "") {
            paneCountClasses += " fadeout";
            openCountClasses += " fadein";
        }

        let designs = this.props.designs;

        let paneOptions = this.getDesignOptions(designs, "apertureCount");

        if (this.state.paneCountValue !== "") {
            designs = designs.filter(design => design.apertureCount === +this.state.paneCountValue);
        }

        let openOptions = this.getDesignOptions(designs, "openingsCount");

        if (this.state.openCountValue !== "") {
            designs = designs.filter(design => design.openingsCount === +this.state.openCountValue);
        }

        let emptyDesigns =
            this.state.paneCountValue &&
            this.state.paneCountValue &&
            Object.keys(designs).length === 0;

        return (
            <form onSubmit={this.props.handleSubmit(this.onSubmit.bind(this))} className="DesignForm">
                <FormHeader title={""} subtitle={""} />

                <SeparatingLine />

                <FormWrapper>
                    <div className={paneCountClasses}>
                        <p>
                            <span className={smallHideClass}>My window will need</span>
                        </p>
                        <br className={smallHideClass + " show-for-small-only"} />
                        <CounterDropdown
                            options={paneOptions}
                            value={this.state.paneCountValue}
                            onChange={value =>
                                this.setState({ paneCountValue: value, openCountValue: "" })
                            }
                        />
                        <p>
                            {this.state.paneCountValue === "1" ? "pane" : "panes"}
                            <span className={smallHideClass}> of glass</span>
                        </p>
                    </div>
                    <div className={openCountClasses}>
                        <p>
                            <span className={smallHideClass}>I need</span>
                        </p>
                        <CounterDropdown
                            options={openOptions}
                            value={this.state.openCountValue}
                            onChange={value => this.setState({ openCountValue: value })}
                        />
                        <p>
                            <span className={smallHideClass}> of those&nbsp;</span>
                        </p>
                        <br className={smallHideClass + " show-for-small-only"} />
                        <p>to open</p>
                    </div>

                    <Field
                        name="WindowDesignId"
                        component={SelectDesign}
                        designs={designs}
                        className={designClasses}
                        emptyDesigns={emptyDesigns}
                        isTiltTurn={this.props.isTiltTurn}
                    />
                </FormWrapper>

                <div className="button-panel">
                    <SeparatingLine />
                    <button className="button back" type="button" onClick={this.props.previousPage}>
                        Back
                    </button>
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    let valueSelector = formValueSelector("WindowWizard");
    let windowStyleId = valueSelector(state, "WindowStyleId") || 1;

    let isTiltTurn = false;

    // if it's the id for tilt&turn
    if (windowStyleId === 3) {
        isTiltTurn = true;
    }



    let selectedWidth = valueSelector(state, "WindowSize.Width");
    let selectedHeight = valueSelector(state, "WindowSize.Height");
    let selectedUnit = valueSelector(state, "WindowSize.Unit");

    let designs = [...state.Window.Designs];

    if (selectedWidth) {
        selectedWidth = utils.convertWindowSize(selectedWidth, selectedUnit, "mm");
        designs = designs.filter(d => d.minWidth <= selectedWidth && selectedWidth <= d.maxWidth);
    }
    if (selectedHeight) {
        selectedHeight = utils.convertWindowSize(selectedHeight, selectedUnit, "mm");
        designs = designs.filter(
            d => d.minHeight <= selectedHeight && selectedHeight <= d.maxHeight
        );
    }

    return {
        designs,
        windowStyleId,
        isTiltTurn,
    };
};

export default connect(mapStateToProps, { getWindowDesigns })(DesignForm);



// WEBPACK FOOTER //
// ./src/containers/WindowForm/DesignForm.js